<div class="ct">

  <!-- ── Hero ─────────────────────────────────────── -->
  <div class="ct__hero">
    <div class="ct__hero-inner">

      <!-- Logo -->
      <div class="ct__brand">
        <img
          src="assets/images/fieldlogo.png"
          alt="KinexOps"
          class="ct__brand-logo"
          onerror="this.style.display='none'"/>
        <span class="ct__brand-name">
          <span class="ct__brand-kinex">Kinex</span><span class="ct__brand-ops">Ops</span>
        </span>
      </div>

      <h1 class="ct__title">Get in Touch</h1>
      <p class="ct__subtitle">
        Have a question, need a demo, or want to discuss a partnership?
        Our team typically responds within one business day.
      </p>

      <!-- Quick contact chips -->
      <div class="ct__quick-links">
        <a href="mailto:hello@kinexops.com" class="ct__quick-link">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <polyline points="22,6 12,13 2,6" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round"/>
          </svg>
          kinexopsinfo&#64;gmail.com
        </a>
        <span class="ct__quick-divider">·</span>
        <span class="ct__quick-link ct__quick-link--plain">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <polyline points="12,6 12,12 16,14" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round"/>
          </svg>
          Mon – Fri, 8 AM – 6 PM WAT
        </span>
      </div>

    </div>
  </div>

  <!-- ── Main layout ───────────────────────────────── -->
  <div class="ct__layout">

    <!-- LEFT — Info cards -->
    <div class="ct__info">

      <div class="ct__info-card">
        <div class="ct__info-icon ct__info-icon--teal">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M21 11.5C21 16.75 13 22 12 22C11 22 3 16.75 3 11.5C3 6.25 7 2 12 2C17 2 21 6.25 21 11.5Z"
                  stroke="currentColor" stroke-width="2"/>
            <circle cx="12" cy="11" r="3" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <div>
          <h3>Request a Demo</h3>
          <p>See KinexOps in action with a live walkthrough tailored to your industry.</p>
        </div>
      </div>

      <div class="ct__info-card">
        <div class="ct__info-icon ct__info-icon--navy">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  stroke="currentColor" stroke-width="2"/>
            <path d="M12 8V12M12 16H12.01"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div>
          <h3>Technical Support</h3>
          <p>Already a customer? Our support team is here to help resolve any issues quickly.</p>
        </div>
      </div>

      <div class="ct__info-card">
        <div class="ct__info-icon ct__info-icon--teal">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M17 21V19C17 16.8 15.2 15 13 15H5C2.8 15 1 16.8 1 19V21"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
            <path d="M23 21V19C23 17.1 21.7 15.5 20 15.1"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M16 3.1C17.7 3.5 19 5.1 19 7C19 8.9 17.7 10.5 16 10.9"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div>
          <h3>Enterprise Sales</h3>
          <p>Large team? We offer custom pricing and dedicated onboarding for enterprise clients.</p>
        </div>
      </div>

      <!-- Response time card -->
      <div class="ct__sla-card">
        <h4 class="ct__sla-title">Typical Response Times</h4>
        <div class="ct__sla-row">
          <span class="ct__sla-type">Sales &amp; Demo</span>
          <span class="ct__sla-time ct__sla-time--fast">Same day</span>
        </div>
        <div class="ct__sla-row">
          <span class="ct__sla-type">Technical Support</span>
          <span class="ct__sla-time ct__sla-time--medium">Within 4 hours</span>
        </div>
        <div class="ct__sla-row">
          <span class="ct__sla-type">General Enquiry</span>
          <span class="ct__sla-time">Within 1 business day</span>
        </div>
        <div class="ct__sla-row">
          <span class="ct__sla-type">Partnership</span>
          <span class="ct__sla-time">Within 2 business days</span>
        </div>
      </div>

    </div>

    <!-- RIGHT — Contact form -->
    <div class="ct__form-wrap">

      <!-- SUCCESS STATE -->
      <div class="ct__success" *ngIf="submitted">
        <div class="ct__success-icon">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill="#2BB0A6"/>
            <path d="M7 12L10 15L17 8" stroke="white"
                  stroke-width="2.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </div>
        <h2 class="ct__success-title">Message Sent!</h2>
        <p class="ct__success-msg">
          Thank you for reaching out. We have received your message and
          a confirmation has been sent to <strong>{{ form.email }}</strong>.
          We will get back to you shortly.
        </p>
        <button class="ct__success-btn" (click)="reset()">
          Send Another Message
        </button>
      </div>

      <!-- FORM STATE -->
      <form class="ct__form" (ngSubmit)="send()" *ngIf="!submitted">

        <div class="ct__form-header">
          <h2 class="ct__form-title">Send us a message</h2>
          <p class="ct__form-sub">All fields marked * are required.</p>
        </div>

        <!-- Error banner -->
        <div class="ct__error-banner" *ngIf="errorMsg">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 8v4M12 16h.01" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round"/>
          </svg>
          {{ errorMsg }}
        </div>

        <!-- Inquiry type -->
        <div class="ct__field ct__field--full">
          <label class="ct__label">What can we help you with? *</label>
          <div class="ct__type-grid">
            <button
              type="button"
              class="ct__type-btn"
              *ngFor="let t of inquiryTypes"
              [class.ct__type-btn--active]="form.inquiryType === t.value"
              (click)="form.inquiryType = t.value">
              {{ t.label }}
            </button>
          </div>
        </div>

        <!-- Name + Email -->
        <div class="ct__row">
          <div class="ct__field">
            <label class="ct__label" for="ct-name">Full Name *</label>
            <input
              id="ct-name"
              class="ct__input"
              type="text"
              [(ngModel)]="form.name"
              name="name"
              placeholder="e.g. Chidi Okeke"
              autocomplete="name"
              required/>
          </div>
          <div class="ct__field">
            <label class="ct__label" for="ct-email">Email Address *</label>
            <input
              id="ct-email"
              class="ct__input"
              type="email"
              [(ngModel)]="form.email"
              name="email"
              placeholder="you@company.com"
              autocomplete="email"
              required/>
            <span class="ct__field-error"
                  *ngIf="form.email && !isValidEmail(form.email)">
              Please enter a valid email address.
            </span>
          </div>
        </div>

        <!-- Company + Phone -->
        <div class="ct__row">
          <div class="ct__field">
            <label class="ct__label" for="ct-company">Company Name</label>
            <input
              id="ct-company"
              class="ct__input"
              type="text"
              [(ngModel)]="form.company"
              name="company"
              placeholder="Your company name"
              autocomplete="organization"/>
          </div>
          <div class="ct__field">
            <label class="ct__label" for="ct-phone">Phone Number</label>
            <input
              id="ct-phone"
              class="ct__input"
              type="tel"
              [(ngModel)]="form.phone"
              name="phone"
              placeholder="+234 ..."
              autocomplete="tel"/>
          </div>
        </div>

        <!-- Subject -->
        <div class="ct__field ct__field--full">
          <label class="ct__label" for="ct-subject">Subject</label>
          <input
            id="ct-subject"
            class="ct__input"
            type="text"
            [(ngModel)]="form.subject"
            name="subject"
            placeholder="Brief summary of your enquiry"/>
        </div>

        <!-- Message -->
        <div class="ct__field ct__field--full">
          <label class="ct__label" for="ct-message">
            Message *
            <span class="ct__char-count">{{ messageLength }}/2000</span>
          </label>
          <textarea
            id="ct-message"
            class="ct__input ct__textarea"
            [(ngModel)]="form.message"
            name="message"
            placeholder="Tell us how we can help you..."
            rows="6"
            maxlength="2000"
            required>
          </textarea>
        </div>

        <!-- Privacy consent -->
        <p class="ct__consent">
          By submitting this form, you agree to our
          <a routerLink="/privacy-policy" target="_blank">Privacy Policy</a>.
          We will use your information solely to respond to your enquiry.
        </p>

        <!-- Submit button -->
        <button
          type="submit"
          class="ct__submit"
          [disabled]="!isValid || submitting">
          <span class="ct__submit-spinner" *ngIf="submitting"></span>
          <svg *ngIf="!submitting" width="16" height="16"
               viewBox="0 0 24 24" fill="none">
            <line x1="22" y1="2" x2="11" y2="13"
                  stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <polygon points="22 2 15 22 11 13 2 9 22 2"
                     stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ submitting ? 'Sending…' : 'Send Message' }}
        </button>

      </form>

    </div>
  </div>

  <!-- ── Footer strip ──────────────────────────────── -->
  <div class="ct__footer">
    <p>© KinexOps Technologies. All rights reserved.</p>
    <div class="ct__footer-links">
      <a routerLink="/privacy-policy">Privacy Policy</a>
      <span>·</span>
      <a href="mailto:kinexopsinfo@gmail.com">kinexopsinfo&#64;gmail.com</a>
    </div>
  </div>

</div>